import { http } from 'common/helpers/axios/axios-helper';
import { 
  AgentVersionModel as Model,
  AgentVersionQuery as Query,
  AgentVersionListModel } from '../model/agent-versions.model';

const basePath = '/agent/versions';

async function getEnabledDownload() {
  return await http.get<boolean>(`${basePath}/download/enabled`);
}

async function getDataList(query?: Query) {
  try {
    // Usando URLSearchParams para melhor tratamento dos parâmetros
    const params = new URLSearchParams();
    
    if (query?.pageNumber) params.append('pageNumber', query.pageNumber.toString());
    if (query?.pageSize) params.append('pageSize', query.pageSize.toString());
    if (query?.orderBy) params.append('orderBy', query.orderBy);
    if (query?.order) params.append('order', query.order);
    
    const url = `${basePath}?${params.toString()}`;
    const response = await http.get<AgentVersionListModel>(url);
    
    return {
      data: response?.data || {
        items: [],
        totalCount: 0,
        pageNumber: query?.pageNumber || 1,
        pageSize: query?.pageSize || 10
      },
      hasErrors: !response
    };
  } catch (error) {
    console.error('Error fetching agent versions:', error);
    return {
      data: {
        items: [],
        totalCount: 0,
        pageNumber: query?.pageNumber || 1,
        pageSize: query?.pageSize || 10
      },
      hasErrors: true
    };
  }
}

async function downloadFile(versionName: String) {
  return await http.download(`${basePath}/${versionName}/download`, {});
}

export const AgentVersionService = {
  getDataList,
  downloadFile,
  getEnabledDownload
};